import * as XLSX from 'xlsx';

/**
 * Genera y descarga un archivo Excel con la plantilla de pagos masivos
 * para transferencias bancarias de las liquidaciones seleccionadas.
 * 
 * @param {Array} settlements Lista de liquidaciones seleccionadas
 */
export const generateBulkPaymentExcel = (settlements) => {
    // Helper para formatear fechas de "YYYY-MM-DD" a "DD/MM"
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            return `${parts[2]}/${parts[1]}`;
        }
        return dateStr;
    };

    // 1. Cabeceras del Excel
    const headers = [
        "Rut Beneficiario",
        "Nombre Beneficiario",
        "Monto",
        "Medio de Pago",
        "Código Banco",
        "Tipo de Cuenta",
        "Número de Cuenta",
        "Email",
        "Referencia Cliente",
        "Glosa Cartola Origen",
        "Glosa Cartola Destino",
        "Detalle de Pago"
    ];

    // 2. Mapear filas
    const rows = settlements.map(s => {
        const driver = s.driver || {};
        const bank = driver.bank || {};

        // Rut conductor (RUT Titular Cuenta de los datos bancarios)
        let rut = (driver.account_rut || "").trim();
        
        // Nombre conductor (de los datos bancarios / full_name)
        const name = (driver.full_name || "").trim().toUpperCase();
        
        // Monto a pagar
        const amount = s.total_amount || 0;

        // Medio de pago: "Abono en Cuenta"
        const paymentMethod = "Abono en Cuenta";
        
        // Código Banco
        const bankCode = bank.code || "";
        
        // Tipo de cuenta ("Cuenta Corriente", "Cuenta Vista", etc.)
        const rawAccountType = (driver.account_type || "").trim().toUpperCase();
        let accountType = driver.account_type || "";
        if (rawAccountType === "CORRIENTE" || rawAccountType === "CUENTA CORRIENTE") {
            accountType = "Cuenta Corriente";
        } else if (rawAccountType === "VISTA" || rawAccountType === "CUENTA VISTA" || rawAccountType === "RUT" || rawAccountType === "CUENTA RUT") {
            accountType = "Cuenta Vista";
        } else if (rawAccountType === "AHORRO" || rawAccountType === "CUENTA AHORRO") {
            accountType = "Cuenta Ahorro";
        }
        
        // Número de cuenta
        const accountNumber = (driver.account_number || "").trim();
        
        // Email (de los datos bancarios / email_notification)
        const email = (driver.email_notification || "").trim();
        
        // Referencia Cliente
        const reference = `LIQ-${s.id}`;
        
        // Glosa Cartola Origen: rango de fecha de la liquidación
        const originGloss = `${formatDate(s.period_start)} al ${formatDate(s.period_end)}`;
        
        // Glosa Cartola Destino
        const destGloss = `LIQ ${s.id}`;

        // Detalle de Pago (estático vacío)
        const paymentDetail = "";

        return [
            rut,
            name,
            amount,
            paymentMethod,
            bankCode,
            accountType,
            accountNumber,
            email,
            reference,
            originGloss,
            destGloss,
            paymentDetail
        ];
    });

    // 3. Crear libro y hoja de cálculo
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);

    // Ajustar ancho de columnas para mejor visualización
    const wscols = [
        { wch: 15 }, // Rut
        { wch: 30 }, // Nombre
        { wch: 15 }, // Monto
        { wch: 18 }, // Medio de pago
        { wch: 15 }, // Codigo Banco
        { wch: 15 }, // Tipo Cuenta
        { wch: 20 }, // Num Cuenta
        { wch: 25 }, // Email
        { wch: 18 }, // Referencia
        { wch: 20 }, // Glosa origen
        { wch: 20 }, // Glosa destino
        { wch: 20 }  // Detalle de Pago
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Pago Masivo Conductores");

    // 4. Escribir y descargar el archivo
    const dateStr = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, `Pago_Masivo_Conductores_${dateStr}.xlsx`);
};
